var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SiteFooterContext, defaultSiteFooterConfig } from "../context/site-footer-context";
import { classNames } from '@shapeable/utils';
var cls = classNames('site-footer');
export var useSiteFooter = function () {
  var context = React.useContext(SiteFooterContext) || {};
  var config = __assign(__assign({}, defaultSiteFooterConfig), context);
  var onClickHandlerForMenuItem = config.onClickHandlerForMenuItem || function (item) {
    return null;
  };
  return __assign(__assign({}, config), {
    onClickHandlerForMenuItem: onClickHandlerForMenuItem
  });
};